import { z } from 'zod';

import type { TranslationFnMap } from '~shared/i18n';

type FacebookShareErrorsKey = 'PAGE_REQUIRED' | 'PHOTO_REQUIRED';

export type FacebookShareFormErrors = TranslationFnMap<FacebookShareErrorsKey>;

export const MAX_MESSAGE_LENGTH = 500;

export const facebookShareSchema = z.object({
  pageId: z.string().min(1, { error: 'PAGE_REQUIRED' }),
  message: z
    .string()
    .min(1, { error: 'MESSAGE_REQUIRED' })
    .max(MAX_MESSAGE_LENGTH, { error: 'MESSAGE_TOO_LONG' }),
  photos: z.array(z.string()).min(1, { error: 'PHOTO_REQUIRED' }),
});

export type FacebookShareFormValues = z.infer<typeof facebookShareSchema>;
